<template>
  <v-list v-bind="listProps" density="compact" class="portal-sidebar-nav py-2">
    <v-list-item
      to="/"
      exact
      rounded="lg"
      class="mb-1"
      :prepend-icon="menuHomeIcon"
      title="Inicio"
      :active="$route.path === '/'"
    />
    <portal-sidebar-nav-group
      v-for="(item, idx) in items"
      :key="itemKey(item, idx)"
      :item="item"
      @nav="$emit('nav', $event)"
    />
  </v-list>
</template>

<script>
import enums from "../../utils/enums";
import PortalSidebarNavGroup from "./PortalSidebarNavGroup.vue";

export default {
  name: "PortalSidebarNav",
  components: { PortalSidebarNavGroup },
  data() {
    return {
      menuHomeIcon: enums.icons.HOME,
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    listProps: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["nav"],
  methods: {
    itemKey(item, idx) {
      return item.id ?? item.path ?? `root-${idx}`;
    },
  },
};
</script>
